import AddApplicantsModalContainer from "./AddApplicantsModalContainer";

export default AddApplicantsModalContainer;
